import { render, staticRenderFns } from "./OrbitAddProjectModal.vue?vue&type=template&id=2d32b079"
import script from "./OrbitAddProjectModal.vue?vue&type=script&lang=ts"
export * from "./OrbitAddProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitAddProjectModal.vue?vue&type=style&index=0&id=2d32b079&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports